import Layout from "@/views/layout/index";

export const Librarian = [
    {
        path: '/Librarian',
        component: Layout,
        redirect: '/Librarian/aiLibrarian',
        name: 'AI建库',
        menuName: 'AI建库',
        meta: {
            title: "AI建库",
            icon: "el-icon-s-finance",
        },
        children: [
            {
                path: 'aiLibrarian',
                component: () => import('@/views/libraryBuilder/BuilderIndex'),
                name: 'AI建库',
                menuName: 'AI建库',
                meta: {title: "AI建库"}
            },
        ]
    },
];
